import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { H2 } from 'foundations-components/transitional/components/H2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function UnmapParticipantModal({
  setPopupToUnmap,
  popupToUnmap,
  onRemoveSubmit,
  appName
}) {
  const {
    hubspotContactName,
    participantName,
    participantId,
    contactId
  } = popupToUnmap;
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": `${appName}-associations-popup-modal`,
    children: [/*#__PURE__*/_jsx(DialogHeader, {
      children: /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "contactList.dialogPopup.header"
        })
      })
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "contactList.dialogPopup.body",
        options: {
          hubspotContactName,
          participantName
        }
      })
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Button, {
        "data-test-id": `${appName}-participants-popup-modal-submit-button`,
        use: "primary",
        onClick: () => {
          setPopupToUnmap({});
          onRemoveSubmit({
            participantId,
            contactId
          });
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "contactList.dialogPopup.unmap"
        })
      }), /*#__PURE__*/_jsx(Button, {
        onClick: () => {
          setPopupToUnmap({});
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "contactList.dialogPopup.cancel"
        })
      })]
    })]
  });
}
export default UnmapParticipantModal;